import { gql } from "@apollo/client";
import { fragments as vinylOrderStatusFragments } from "../../application/apps/VinylApp/components/VinylOrderStatus/graph";

const markOrderAsVinylCutMutation = gql`
  mutation($orderId: ID!) {
    markOrderAsVinylCut(orderId: $orderId) {
      errors {
        orderId
      }
      order {
        ...VinylOrderStatus_order
      }
      succeeded
    }
  }
  ${vinylOrderStatusFragments.order}
`;

export default markOrderAsVinylCutMutation;
